import { prettifySSN } from '@kvika/string-utils'
import * as React from 'react'
import { InputAttributes, NumberFormatBase, NumericFormatProps } from 'react-number-format'

import Input from './Input'
import { StyledContainerPhoneSSNCurrency, StyledLabel, StyledTopContainer } from './styles/InputStyles'

const getFormatSSN = (ssn: string) => {
	if (ssn.length > 6) {
		return prettifySSN(ssn)
	}
	return ssn
}

type CustomProps = {
	label?: React.ReactNode
	name?: string
	width: string
	autoFocus?: boolean
	onChange: (event: { target: { name: string; value: string } }) => void
	className?: string
	id?: string
	testId?: string
	error?: boolean
	errorText?: string
	validText?: string
	valid?: boolean
}

type Props = NumericFormatProps<InputAttributes> & CustomProps

const NumberFormatSSN = React.forwardRef(
	({ label, width, onChange, autoFocus, className, id, testId, ...other }: Props, ref: React.Ref<HTMLInputElement>) => {
		return (
			<StyledContainerPhoneSSNCurrency width={width} className={className}>
				<NumberFormatBase
					{...other}
					removeFormatting={(value) => value.replace('-', '')}
					getCaretBoundary={(value: string) => {
						const boundaries = Array.from({ length: value.length + 1 }).map(() => {
							return true
						})
						return boundaries
					}}
					format={getFormatSSN}
					getInputRef={ref}
					type='tel'
					isAllowed={(values) => {
						const { value } = values
						if (value === undefined) {
							return true
						}
						return value.length <= 10
					}}
					customInput={Input}
					width={width}
					onChange={onChange}
					autoFocus={autoFocus}
				/>
				{label === undefined ? null : (
					<StyledTopContainer>
						{label && (
							<StyledLabel data-testid={`${testId}-label`} htmlFor={id}>
								{label}
							</StyledLabel>
						)}
					</StyledTopContainer>
				)}
			</StyledContainerPhoneSSNCurrency>
		)
	}
)

NumberFormatSSN.displayName = 'NumberFormatSSN'

export default NumberFormatSSN
